import React, { useState } from 'react';
import { proxyLlm } from '../services/llm';

const LlmAccessPage: React.FC = () => {
    const [model, setModel] = useState('chatgpt');
    const [prompt, setPrompt] = useState('');
    const [response, setResponse] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError('');
        setResponse('');

        try {
            const data = await proxyLlm(model, prompt);
            setResponse(JSON.stringify(data, null, 2));
        } catch (err: any) {
            setError(err.response?.data?.message || 'An error occurred');
        }
    };

    return (
        <div className="container mx-auto px-4">
            <h1 className="text-4xl font-bold text-center my-8">LLM Access</h1>

            <form onSubmit={handleSubmit} className="mb-8">
                <div className="mb-4">
                    <label htmlFor="model" className="block text-gray-700">Model</label>
                    <select id="model" value={model} onChange={e => setModel(e.target.value)} className="border rounded w-full py-2 px-3">
                        <option value="chatgpt">ChatGPT</option>
                        <option value="claude">Claude</option>
                        <option value="gemini">Gemini</option>
                    </select>
                </div>
                <div className="mb-4">
                    <label htmlFor="prompt" className="block text-gray-700">Prompt</label>
                    <textarea id="prompt" value={prompt} onChange={e => setPrompt(e.target.value)} className="border rounded w-full py-2 px-3" rows={5}></textarea>
                </div>
                <button type="submit" className="bg-blue-500 text-white px-4 py-2 rounded">Submit</button>
            </form>

            {response && (
                <div className="border rounded-lg p-8">
                    <h2 className="text-2xl font-bold mb-4">Response</h2>
                    <pre>{response}</pre>
                </div>
            )}

            {error && (
                <div className="border rounded-lg p-8 mt-4 bg-red-100 text-red-700">
                    <h2 className="text-2xl font-bold mb-4">Error</h2>
                    <p>{error}</p>
                </div>
            )}
        </div>
    );
};

export default LlmAccessPage;